import ApiHelper from '@/common/ApiHelper';
import { Toast } from 'antd-mobile';
import axios from 'axios';
import captchaSDK from '@df-fe/captcha-sdk';

const api = new ApiHelper();

const APPAPI_URL = process.env.APPAPI_URL;

const codeUrl = {
  postMessageUrl: APPAPI_URL + '/sms/sendVerificationCodeMsg',
  vertifyMessageUrl: APPAPI_URL + '/sms/verifyVerificationCode'
};

// 创建 axios 实例（专用于验证码拦截）
const captchaAxiosInstance = axios.create({
  // baseURL: APPAPI_URL,
  timeout: 30000,
  withCredentials: true // 携带 cookie
});

// 配置验证码拦截
captchaSDK.configCaptcha(captchaAxiosInstance, {
  sendUrls: [codeUrl.postMessageUrl],
  captchaCode: 222648
});

/** 获取验证码（使用 axios 以支持图形验证码拦截） */
const getVerificationCode = async (params) => {
  try {
    const response = await captchaAxiosInstance.post(codeUrl.postMessageUrl, params);
    // SDK 拦截：验证码验证通过后才会执行到这里
    const res = response.data;
    if (res.code !== 0) {
      Toast.info(res.msg);
      return undefined;
    }
    return res.body;
  } catch (error) {
    // 用户关闭验证码弹窗或验证失败
    throw error;
  }
};

/** 验证验证码 */
const verifyVerificationCode = (params) =>
  api.Post(codeUrl.vertifyMessageUrl, params).then((res: any) => {
    if (res.Status !== 0) {
      Toast.info(res.Message);
      return undefined;
    } else {
      return res.Data;
    }
  });

export default {
  getVerificationCode,
  verifyVerificationCode
};
